export class Pedestrian {
    get id() {
        return this.pedestrianState.id;
    }
    get diligenceNumber() {
        return this.pedestrianState.diligenceNumber;
    }
    get pedestrianThirId() {
        return this.pedestrianState.pedestrianThirId;
    }
    get manifestation() {
        return this.pedestrianState.manifestation;
    }
    get dateCreated() {
        return this.pedestrianState.dateCreated;
    }
    get present() {
        return this.pedestrianState.present;
    }
    get optionalPart() {
        return this.pedestrianState.optionalPart;
    }
    get medicalHistory() {
        return this.pedestrianState.medicalHistory;
    }
    get userId() {
        return this.pedestrianState.userId;
    }
    get third_name() {
        return this.pedestrianState.third_name;
    }
    set diligenceNumber(diligenceNumber) {
        this.pedestrianState.diligenceNumber = diligenceNumber;
    }
    set pedestrianThirId(pedestrianThirId) {
        this.pedestrianState.pedestrianThirId = pedestrianThirId;
    }
    set manifestation(manifestation) {
        this.pedestrianState.manifestation = manifestation;
    }
    set dateCreated(dateCreated) {
        this.pedestrianState.dateCreated = dateCreated;
    }
    set present(present) {
        this.pedestrianState.present = present;
    }
    set optionalPart(optionalPart) {
        this.pedestrianState.optionalPart = optionalPart;
    }
    set medicalHistory(medicalHistory) {
        this.pedestrianState.medicalHistory = medicalHistory;
    }
    set userId(userId) {
        this.pedestrianState.userId = userId;
    }
    constructor(pedestrianState) {
        this.pedestrianState = pedestrianState;
    }
    getState() {
        return this.pedestrianState;
    }
}
